import { render, staticRenderFns } from "./noticeBanner.vue?vue&type=template&id=79f72888&scoped=true&"
import script from "./noticeBanner.vue?vue&type=script&lang=js&"
export * from "./noticeBanner.vue?vue&type=script&lang=js&"
import style0 from "./noticeBanner.vue?vue&type=style&index=0&id=79f72888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f72888",
  null
  
)

export default component.exports